// src/modules/app-views/_apps/appmulti/receivables/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR — split flat fee fields into value/percentage/type
// (percentage-only port — Divergence #5)
// *******************************************************************************
const decorateRequest = ctx => {
  const { data, allValues } = ctx;
  if (!data) return data;

  const transformed = { ...data };

  const splitFee = (formKey, prefix) => {
    const raw = transformed[formKey] ?? allValues?.[formKey];
    if (raw == null) return;
    transformed[`${prefix}Type`] = 'percentage';
    transformed[`${prefix}Percentage`] = raw;
    transformed[`${prefix}Value`] = 0;
    delete transformed[formKey];
  };

  splitFee('interest', 'interest');
  splitFee('fine', 'fine');
  splitFee('discount', 'discount');

  // Ensure billingType/status survive a partial diff
  if (!transformed.billingType && allValues?.billingType) {
    transformed.billingType = allValues.billingType;
  }

  return transformed;
};

export default decorateRequest;
